export default "/kiban/_next/static/images/close-fcbbe0183aa085fbb9d1e96c01618811.svg";